var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-more"},[_c('div',{staticClass:"view-more-content",on:{"click":_vm.gotoMore}},[_vm._v(" "+_vm._s(_vm.translateTitle("查看更多"))+" "),_c('img',{attrs:{"src":_vm.isDarkMode ? _vm.rightIcon : _vm.rightIconLight}})])])}
var staticRenderFns = []

export { render, staticRenderFns }